import styled from 'styled-components'
import {
  color,
  space,
  border,
  layout,
  position,
  flexbox,
  grid,
  compose,
  system,
  background,
} from 'styled-system'

const cursor = system({
  cursor: true,
})

export const styleProps = compose(
  color,
  space,
  border,
  layout,
  position,
  flexbox,
  grid,
  cursor,
  background,
)

const Span = styled.span(
  {
    boxSizing: 'border-box',
  },
  system({
    transition: {
      property: 'transition',
    },
  }),
  styleProps,
  ({ sx }) => sx,
)

export default Span
